import {Dimensions, StyleSheet} from 'react-native';

import {scaleFonts} from '@buncha/appStyles/style/font';

const {width} = Dimensions.get('window');

const SPACING = 5;
const ITEM_LENGTH = width * 0.7; // Item is a square. Therefore, its height and width are of the same length.
const BORDER_RADIUS = 20;

export const styles = StyleSheet.create({
  dataContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    // flexGrow: 1,
  },
  rowFlex: {
    flexDirection: 'row',
  },
  iconStyle: {
    marginRight: 15,
  },
  jCC: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  mainContainer: {flex: 1},
  iconBox: {marginRight: 5},
  buttonStyle: {marginBottom: 10},
  bottomContainer: {
    paddingTop: 5,
    borderTopWidth: 1,
  },
  marBot: {marginBottom: 50},
  divider: {marginVertical: 5},
  itemContent: {
    marginRight: 5,
    alignItems: 'center',
    backgroundColor: 'white',
    padding: 20,
    borderRadius: BORDER_RADIUS + SPACING * 2,
    zIndex: 2,
  },
  itemImage: {
    width: Dimensions.get('window').width - scaleFonts(87),
    height: ITEM_LENGTH,
    borderRadius: BORDER_RADIUS,
  },
  pillBody: {
    flexDirection: 'row',
    position: 'absolute',
    right: 0,
    top: 40,
    zIndex: 1,
  },
  bodyContainer: {
    padding: 10,
    paddingHorizontal: 20,
    height: '100%',
    marginBottom: '10%',
    flex: 1,
    paddingBottom: 100,
  },
  ItemNameTypo: {
    textAlign: 'left',
  },
  BottomContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 10,
  },
  replaceButtonStyle: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  header: {
    flex: 1,
  },
  aoosStatus: {
    padding: 10,
  },
  modalBody: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
});
